// 获取css变量
export const getCssVar = (prop, dom = document.documentElement) => {
  return getComputedStyle(dom).getPropertyValue(prop).trim()
}

// 设置css变量
export const setCssVar = (prop, val, dom = document.documentElement) => {
  dom.style.setProperty(prop, val)
}
